import { TServerErrorResponse, SpeakerMetadataEntity } from "@/types";
import { http } from "../httpHandler";
import { links } from "@/constants";

export const SPEAKER_METADATA_GET = "speaker-metadata-get";

export const getSpeakerMetadata = async (conversationId: string): Promise<SpeakerMetadataEntity[]> => {
  try {
    const response = await http.get<SpeakerMetadataEntity[]>(
      links.speakerMetadata.byConversationId(conversationId)
    );
    return response.data;
  } catch (error) {
    throw error as TServerErrorResponse;
  }
}; 